<template>
    <div class="history">
        <!-- <Button slot="tootipL"
                class="btn"
                :disabled="disabledDo || isLocak"
                @click="addSecuriytGroup()"
                type="primary">
            绑定安全组
        </Button> -->
        <rc-table ref="rcTable"
                  :tableAttr="tableAttr" />
        <!-- <rules ref="envsecrules"
               :rulesData="rulesData"></rules>
        <modalSecurityGroup ref="addModal"
                            :data="baseInfo"
                            :envName="envName"
                            @refresh="refresh1"></modalSecurityGroup> -->
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
// import rules from '@/views/console/securitygroup/rules'
// import modalSecurityGroup from './modalSecurityGroup'
import API from '@/service/api'
export default {
    name: 'history',
    props: ['id', 'baseInfo', 'envName', 'isLocak'],
    components: {
        rcTable
    },
    data () {
        return {
            rulesData: {},
            info: {},
            envType: this.$route.query.envType,
            tableAttr: {
                hideHead: true,
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_SECURITY_GROUPS, true),
                    params: {
                        envId: this.id,
                        instanceId: this.baseInfo.id || ''
                    }
                },
                columns: [
                    {
                        key: 'uuid',
                        title: '资源ID',
                        className: 'rc-ellipsis',
                        render: (h, params) => {
                            return h('a', { on: { click: () => this.rulesFun(params.row.securityGroupRules) } }, params.row.uuid)
                        }
                    },
                    {
                        key: 'name',
                        title: '名称',
                        className: 'rc-ellipsis'
                    },
                    {
                        key: 'vpcName',
                        title: '所属专有网络',
                        className: 'rc-ellipsis'
                    },
                    {
                        key: 'description',
                        title: '描述',
                        className: 'rc-ellipsis'
                    }
                ]
            }
        }
    },
    computed: {
        disabledDo () {
            const item = this.baseInfo
            const status = this.baseInfo.status
            if (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'Aliyun', 'Qcloud', 'HuaweiCloud', 'Aws'].includes(item.cloudEnvType) && (status === 'stopped' || status === 'running')) {
                return false
            }
            return true
        }
    },
    methods: {
        // 查看安全组规则
        rulesFun (obj) {
            this.rulesData = JSON.parse(obj)
            this.$refs.envsecrules.openModal()
        },
        addSecuriytGroup () {
            this.$refs.addModal.openModal()
        },
        refresh () {
            this.$refs.rcTable.refreshTable()
        },
        refresh1 () {
            this.refresh()
            this.$emit('update')
        }
    }
}
</script>
<style lang="less" scoped>
.btn {
    margin-bottom: 16px;
}
</style>
